<template>
  <div
    class="exhibition"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="exhibitionTop eng_exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">Regong Works Exhibition</span>
        </div>
        <div class="search_input" v-if="this.isMobile">
          <el-input
            ref="searchInput"
            v-model="Info.chineseName"
            placeholder="Please enter the art academy"
            @focus="handleFocus"
            @blur="handleBlur"
          ></el-input>
          <div class="searchButton" @click="handSearchOther()">
            <img src="../../assets/newImageBgc/search.png" alt />
          </div>
        </div>
        <div class="search_input" v-else>
          <el-input
            ref="searchInput"
            v-model="queryInfo.chineseName"
            placeholder="Please enter the art academy"
            @focus="handleFocus"
            @blur="handleBlur"
          ></el-input>
          <div class="searchButton" @click="handSearchOther()">
            <img src="../../assets/newImageBgc/search.png" alt />
          </div>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt
      />
    </div>
    <div class="sectionType eng_sectionType">
      <div @click="goDataDetail(1)">
        <img src="../../assets/exhibitionImage/One.jpg" alt="" />
        <div class="type eng_type">Thangka</div>
      </div>
      <div @click="goDataDetail(2)">
        <img src="../../assets/exhibitionImage/Two.jpg" alt="" />
        <div class="type eng_type">Clay sculpture</div>
      </div>
      <div @click="goDataDetail(3)">
        <img src="../../assets/exhibitionImage/Three.jpg" alt="" />
        <div class="type eng_type">Mural</div>
      </div>
      <div @click="goDataDetail(4)">
        <img src="../../assets/exhibitionImage/Four.jpg" alt="" />
        <div class="type eng_type">Pile embroidery</div>
      </div>
      <div @click="goDataDetail(5)">
        <img src="../../assets/exhibitionImage/Five.jpg" alt="" />
        <div class="type eng_type">Paintings</div>
      </div>
      <div @click="goDataDetail(6)">
        <img src="../../assets/exhibitionImage/Six.jpg" alt="" />
        <div class="type eng_type">Other</div>
      </div>
    </div>
    <div class="section">
      <div class="exhibitionContent">
        <div
          class="exhibitionItem hidden-xs-only"
          v-for="(exhibitionItem, index) in exhibitionList"
          :key="index"
          @click="goDetail(exhibitionItem.id)"
        >
          <div class="Img">
            <img
              class="img"
              :src="url + exhibitionItem.picture[0].thinUrl"
              alt
            />
            <div class="mask">
              <span class="name eng_name">
                <span class="names eng_names">{{ exhibitionItem.englishName }}</span>
                <span class="names eng_names" v-if="exhibitionItem.englishLocation">-{{exhibitionItem.englishLocation}}</span>
              </span>
            </div>
          </div>
          <div class="bottomTitle eng_bottomTitle">
            {{ exhibitionItem.englishName }}
            <span v-if="exhibitionItem.englishLocation">-{{exhibitionItem.englishLocation}}</span>
          </div>
        </div>
        <div
          class="exhibitionItemss hidden-sm-and-up wow animate__animated animate__fadeInUp"
          v-for="(exhibitionItem, index) in mobileExhibitionList"
          :key="index + '-'"
          @click="goDetail(exhibitionItem.id)"
        >
          <div class="Imgs">
            <img
              class="imgs"
              :src="url + exhibitionItem.picture[0].thinUrl"
              alt
            />
            <div class="masks">
              <div class="Toptitles">
                <span class="title eng_title">{{ exhibitionItem.englishName }}</span>
                <span class="title eng_title" v-if="exhibitionItem.englishLocation">-{{exhibitionItem.englishLocation}}</span>
              </div>
            </div>
          </div>
          <div class="bottomTitle eng_bottomTitle">
            {{ exhibitionItem.englishName }}
            <span v-if="exhibitionItem.englishLocation">-{{exhibitionItem.englishLocation}}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="loading"
      v-loading="loading"
      element-loading-text="loading"
      element-loading-spinner="el-icon-loading"
    ></div>
  </div>
  <div class="exhibition" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color"> རེབ་གོང་བརྩམས་ཆོས་འགྲེམ་སྤེལ། </span>
        </div>
        <div class="search_input" v-if="this.isMobile">
          <el-input
            ref="searchInput"
            v-model="Info.chineseName"
            placeholder="རི་མོའི་སློབ་གླིང་གི་མིང་ནང་འཇུག་རོགས་།"
            @focus="handleFocus"
            @blur="handleBlur"
          ></el-input>
          <div class="searchButton" @click="handSearchOther()">
            <img src="../../assets/newImageBgc/search.png" alt />
          </div>
        </div>
        <div class="search_input" v-else>
          <el-input
            ref="searchInput"
            v-model="queryInfo.chineseName"
            placeholder="རི་མོའི་སློབ་གླིང་གི་མིང་ནང་འཇུག་རོགས་།"
            @focus="handleFocus"
            @blur="handleBlur"
          ></el-input>
          <div class="searchButton" @click="handSearchOther()">
            <img src="../../assets/newImageBgc/search.png" alt />
          </div>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt
      />
    </div>
    <div class="sectionType">
      <div @click="goDataDetail(1)">
        <img src="../../assets/exhibitionImage/One.jpg" alt="" />
        <div class="type">ཐང་ག</div>
      </div>
      <div @click="goDataDetail(2)">
        <img src="../../assets/exhibitionImage/Two.jpg" alt="" />
        <div class="type">འཇིམ་བཟོ།</div>
      </div>
      <div @click="goDataDetail(3)">
        <img src="../../assets/exhibitionImage/Three.jpg" alt="" />
        <div class="type">ལྡེབས་རིས།</div>
      </div>
      <div @click="goDataDetail(4)">
        <img src="../../assets/exhibitionImage/Four.jpg" alt="" />
        <div class="type">དྲས་དྲུབ།</div>
      </div>
      <div @click="goDataDetail(5)">
        <img src="../../assets/exhibitionImage/Five.jpg" alt="" />
        <div class="type">ཚོན་རིས།</div>
      </div>
      <div @click="goDataDetail(6)">
        <img src="../../assets/exhibitionImage/Six.jpg" alt="" />
        <div class="type">གཞན་དག</div>
      </div>
    </div>
    <div class="section">
      <div class="exhibitionContent">
        <div
          class="exhibitionItem hidden-xs-only"
          v-for="(exhibitionItem, index) in exhibitionList"
          :key="index"
          @click="goDetail(exhibitionItem.id)"
        >
          <div class="Img">
            <img
              class="img"
              :src="url + exhibitionItem.picture[0].thinUrl"
              alt
            />
            <div class="mask">
              <span class="name">
                <span class="names za_names">{{ exhibitionItem.zangName }}</span>
                <span class="names za_names" v-if="exhibitionItem.zangLocation">-{{exhibitionItem.zangLocation}}</span>
              </span>
            </div>
          </div>
          <div class="bottomTitle">
            {{ exhibitionItem.zangName }}
            <span v-if="exhibitionItem.zangLocation">-{{exhibitionItem.zangLocation}}</span>
          </div>
        </div>
        <div
          class="exhibitionItemss hidden-sm-and-up wow animate__animated animate__fadeInUp"
          v-for="(exhibitionItem, index) in mobileExhibitionList"
          :key="index + '-'"
          @click="goDetail(exhibitionItem.id)"
        >
          <div class="Imgs">
            <img
              class="imgs"
              :src="url + exhibitionItem.picture[0].thinUrl"
              alt
            />
            <div class="masks">
              <div class="Toptitles">
                <span class="title">
                  {{ exhibitionItem.zangName }}
                  <span v-if="exhibitionItem.zangLocation">-{{exhibitionItem.zangLocation}}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="bottomTitle za_bottomTitle">
            {{ exhibitionItem.zangName }}
            <span v-if="exhibitionItem.zangLocation">-{{exhibitionItem.zangLocation}}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="loading"
      v-loading="loading"
      element-loading-text="གཞི་གྲངས་སྣོན་འཇུག་ཁྲོད་"
      element-loading-spinner="el-icon-loading"
    ></div>
  </div>
  <div class="exhibition" v-else>
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">热贡作品展</span>
        </div>
        <div class="search_input" v-if="isMobile">
          <el-input
            ref="searchInput"
            v-model="Info.chineseName"
            placeholder="请输入画院名称"
            @focus="handleFocus"
            @blur="handleBlur"
          ></el-input>
          <div class="searchButton" @click="handSearchOther()">
            <img src="../../assets/newImageBgc/search.png" alt />
          </div>
        </div>
        <div class="search_input" v-if="!isMobile">
          <el-input
            ref="searchInput"
            v-model="queryInfo.chineseName"
            placeholder="请输入画院名称"
            @focus="handleFocus"
            @blur="handleBlur"
          ></el-input>
          <div class="searchButton" @click="handSearchOther()">
            <img src="../../assets/newImageBgc/search.png" alt />
          </div>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt
      />
    </div>
    <div class="sectionType">
      <div @click="goDataDetail(1)">
        <img src="../../assets/exhibitionImage/One.jpg" alt="" />
        <div class="type">唐&nbsp;&nbsp;&nbsp;卡</div>
      </div>
      <div @click="goDataDetail(2)">
        <img src="../../assets/exhibitionImage/Two.jpg" alt="" />
        <div class="type">泥&nbsp;&nbsp;&nbsp;塑</div>
      </div>
      <div @click="goDataDetail(3)">
        <img src="../../assets/exhibitionImage/Three.jpg" alt="" />
        <div class="type">壁&nbsp;&nbsp;&nbsp;画</div>
      </div>
      <div @click="goDataDetail(4)">
        <img src="../../assets/exhibitionImage/Four.jpg" alt="" />
        <div class="type">堆&nbsp;&nbsp;&nbsp;绣</div>
      </div>
      <div @click="goDataDetail(5)">
        <img src="../../assets/exhibitionImage/Five.jpg" alt="" />
        <div class="type">彩&nbsp;&nbsp;&nbsp;绘</div>
      </div>
      <div @click="goDataDetail(6)">
        <img src="../../assets/exhibitionImage/Six.jpg" alt="" />
        <div class="type">其&nbsp;&nbsp;&nbsp;他</div>
      </div>
    </div>
    <div class="section">
      <div class="exhibitionContent">
        <div
          class="exhibitionItem hidden-xs-only"
          v-for="(exhibitionItem, index) in exhibitionList"
          :key="index"
          @click="goDetail(exhibitionItem.id)"
        >
          <div class="Img">
            <img
              class="img"
              :src="url + exhibitionItem.picture[0].thinUrl"
              alt
            />
            <div class="mask">
              <span class="name">
                <span class="names">
                  {{ exhibitionItem.chineseName }}
                  <span v-if="exhibitionItem.chineseLocation">-{{exhibitionItem.chineseLocation}}</span>
                </span>
              </span>
            </div>
          </div>
          <div class="bottomTitle cn_bottomTitle">
            {{ exhibitionItem.chineseName }}
            <span v-if="exhibitionItem.chineseLocation">-{{exhibitionItem.chineseLocation}}</span>
          </div>
        </div>
        <div
          class="exhibitionItemss hidden-sm-and-up wow animate__animated animate__fadeInUp"
          v-for="(exhibitionItem, index) in mobileExhibitionList"
          :key="index + '-'"
          @click="goDetail(exhibitionItem.id)"
        >
          <div class="Imgs">
            <img
              class="imgs"
              :src="url + exhibitionItem.picture[0].thinUrl"
              alt
            />
            <div class="masks">
              <div class="Toptitles">
                <span class="title">
                  {{ exhibitionItem.chineseName }}
                  <span v-if="exhibitionItem.chineseLocation">-{{exhibitionItem.chineseLocation}}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="bottomTitle cn_bottomTitle">
            {{ exhibitionItem.chineseName }}
            <span v-if="exhibitionItem.chineseLocation">-{{exhibitionItem.chineseLocation}}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="loading"
      v-loading="loading"
      element-loading-text="数据加载中"
      element-loading-spinner="el-icon-loading"
    ></div>
  </div>
</template>
<script>
import { templePage } from "../../api/management.js";
import PicTop from "../../components/picsTop.vue";
import { throttle } from 'lodash'
export default {
  components: {
    PicTop,
  },
  data() {
    return {
      language: this.$store.state.language,
      url: process.env.VUE_APP_WEB_URL,
      total: null,
      queryInfo: {
        current: 1,
        pageSize: 9,
        chineseName: '',
      },
      exhibitionList: [],
      mobileTotal: null,
      mobileExhibitionList: [],
      Info: {
        current: 1,
        pageSize: 8,
        chineseName: '',
      },
      loading: false,
      isLoading:false,//是否加载中
      isMobile: false,
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  mounted() {
    new this.$wow.WOW().init();
  },
  created() {
    this.getPCorMobile();
  },
  methods: {
    getPCorMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.getMobileTemplePage();
        this.isMobile = true;
        window.addEventListener("scroll", this.Scrollbottom, true);
      } else {
        this.getTemplePage();
        this.isMobile = false;
        window.addEventListener("scroll", this.PCscrollBottom, true);
      }
    },
    async getTemplePage() {
      this.loading = true;
      const res = await templePage(this.queryInfo);
      if (res.code == 1) {
        this.loading = false
        this.isLoading = false
        this.exhibitionList = this.exhibitionList.concat(res.data.records);
        this.total = res.data.total;
      }
    },
    PCscrollBottom() {
      // 变量scrollTop为当前页面的滚动条纵坐标位置
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 变量 windowHeight 是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 变量 scrollHeight 是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 到底的条件
      if (scrollTop + windowHeight == scrollHeight) {
        //到底后要去触发的事件
        if(this.isLoading) {
          if (this.queryInfo.current * 9 >= this.total) {
            this.isLoading = false
            return this.$message("数据加载完毕");
          }
          this.loading = true;
          this.queryInfo.current++;
          this.getTemplePage();
        }
      } else {
        this.isLoading = true
      }
    },
    async getMobileTemplePage() {
      this.loading = true;
      const res = await templePage(this.Info);
      if (res.code == 1) {
        this.isLoading = false
        this.loading = false
        this.mobileExhibitionList = this.mobileExhibitionList.concat(
          res.data.records
        );
        this.mobileTotal = res.data.total;
      }
    },
    Scrollbottom:throttle(function(event) {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 变量 windowHeight 是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 变量 scrollHeight 是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 到底的条件
      if (scrollTop + windowHeight + 100 >= scrollHeight) {
        //到底后要去触发的事件
        if(this.isLoading) {
          if (this.Info.current * 8 >= this.mobileTotal) {
            this.isLoading = false
            return this.$message("数据加载完毕");
          }
          this.loading = true;
          this.Info.current++;
          this.getMobileTemplePage();
        }
      } else {
        this.isLoading = true
      }
    },2000),
    goDetail(id) {
      this.$router.push({ path: "/exhibitionDetail", query: { id: id } });
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
    goDataDetail(index) {
      this.$router.push({
        path: "/exhibitionWork",
        query: { category: index },
      });
    },
    handSearchOther() {
      if(this.isMobile) {
        // 手机
        this.Info.current = 1
        this.mobileExhibitionList = []
        this.mobileTotal = null
        this.getMobileTemplePage()
      } else {
        // PC
        this.queryInfo.current = 1
        this.exhibitionList = []
        this.total = null
        this.getTemplePage()
      }
    },
    handleFocus(event) {
      // 获取input的DOM元素
      const input = this.$refs.searchInput.$el.querySelector('input');
      // 添加自定义的边框颜色
      input.style.border = '1px solid #9a131b';
    },
    handleBlur(event) {
      // 当input失去焦点时，恢复边框颜色
      const input = this.$refs.searchInput.$el.querySelector('input');
      input.style.border = '1px solid #DCDFE6';
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.PCscrollBottom, true);
    window.removeEventListener("scroll", this.Scrollbottom, true);
  },
};
</script>
<style lang="scss" scoped>
.exhibition {
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  background-size: 7%;
  .exhibitionTop {
    position: relative;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      border-bottom: 1px solid #f4f5f6;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
      .search_input {
        position: absolute;
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
        z-index: 88;
        display: flex;
        .el-input {
          width: 240px;
          /deep/.el-input__inner {
            width: 240px;
            padding: 0 32px 0 15px!important;
          }
        }
        .searchButton {
          position: absolute;
          top: 50%;
          right: 5px;
          transform: translateY(-50%);
          color: #fff;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          img {
            height: 26px;
          }
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: 50%;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  .sectionType {
    display: flex;
    width: 1200px;
    justify-content: space-between;
    margin: 0 auto;
    cursor: pointer;
  }
  .sectionType > div {
    // width: 230px;
    height: 110px;
    position: relative;
    overflow: hidden;
    img {
      cursor: pointer;
      text-align: right;
      object-fit: contain;
      width: 100%;
      transition: all 1s ease;
      height: 100%;
    }
    .type {
      white-space: nowrap;
      position: absolute;
      text-align: center;
      font-size: 20px;
      color: #fff;
      font-family: "fangzang";
      right: 10px;
      bottom: 2px;
    }
    .eng_type {
      font-family: "Times New Roman", Times, serif;
      font-size: 17px;
      bottom: 4px;
    }
  }
  .sectionType > div:hover img {
    transform: scale(1.1);
  }
  .section {
    .exhibitionContent {
      margin-top: 40px;
      width: 100%;
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      .exhibitionItem {
        cursor: pointer;
        position: relative;
        width: 354px;
        margin-bottom: 20px;
        margin-right: 68px;
        height: 280px;
        overflow: hidden;
        .Img {
          cursor: pointer;
          position: relative;
          height: 240px;
          width: 354px;
          overflow: hidden;
          .img {
            height: 240px;
            width: 354px;
            object-fit: cover;
            transition: all 1s ease;
          }
          .mask {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            bottom: 0;
            transform: translateY(100%);
            transition: all 0.5s ease;
            .name {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              background-color: #0e162d;
              padding: 12px 22px;
              color: #ed201a;
              opacity: 0.9;
              text-align: center;
              .names {
                font-size: 30px;
                background: linear-gradient(to bottom, #fffdb6, #ffc000);
                -webkit-background-clip: text;
                color: transparent;
              }
              .za_names {
                font-size: 20px;
                span {
                  display: inline-block;
                }
              }
              .eng_names {
                font-size: 14px;
              }
            }
            .eng_name {
              padding: 12px 10px;
            }
          }
        }
        .bottomTitle {
          width: 100%;
          position: absolute;
          text-align: center;
          bottom: 0;
          font-size: 22px;
        }
        .cn_bottomTitle {
          font-family: "fangzang";
        }
        .eng_bottomTitle {
          font-size: 17px;
        }
        .Toptitle {
          display: flex;
          flex-direction: column;
          .title {
            font-size: 16px;
            font-family: "fangzang";
          }
        }
        .Toptype {
          display: flex;
          flex-direction: column;
          position: absolute;
          top: 30%;
          left: 70%;
          transform: translate(-55%, 10%);
          .type {
            font-size: 28px;
            font-family: "fangzang";
            color: #d9ddb7;
          }
        }
        .name {
          font-size: 24px;
          font-family: "fangzang";
        }
      }
      .exhibitionItem:hover .mask {
        display: block;
        bottom: 236px;
      }
      .exhibitionItem:hover .img {
        transform: scale(1.1);
      }
      .exhibitionItem:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
  .loading {
    margin-bottom: 20px;
    .el-loading-mask {
      .el-loading-spinner {
        .el-icon-loading {
          color: #ef3731;
        }
        .el-loading-text {
          color: #ef3731;
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .exhibition {
    background-size: 15%;
    .exhibitionTop {
      .section {
        background: url("../../assets/newImage/index/could_left.png") no-repeat
          top left;
        background-position: 0 50%;
        background-size: 15%;
        padding: 0.6rem 0.2rem;
        font-size: 0.34rem;
        .section_left {
          left: 0.2rem;
        }
        .search_input {
          position: absolute;
          top: 50%;
          right: .2rem!important;
          transform: translateY(-50%);
          z-index: 88;
          display: flex;
          margin-bottom: 20px;
          width: 3.5rem;
          .el-input {
            width: 100%;
            height: .7rem;
            /deep/ .el-input__inner {
              width:100%!important;
              font-size: .25rem;
              height: .7rem;
              padding: 0 45px 0 15px!important;
            }
          }
          /deep/.searchButton {
            position: absolute;
            top: 50%;
            right: 0.1rem;
            transform: translateY(-50%);
            color: #fff;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            img {
              height: .5rem;
            }
          }
        }
      }
    }
    .eng_exhibitionTop {
      .section {
        width: 100%;
        padding: 0.6rem 0.2rem 1rem 0;
        .section_left {
          position: relative!important;
        }
        .search_input {
          width: 92%;
          top: 62%;
          left: .2rem!important;
        }
      }
    }
    .sectionType {
      display: flex;
      width: 100%;
      margin: 0 auto;
      flex-wrap: wrap;
    }
    .sectionType > div {
      height: 2.4rem !important;
      padding: 0.16rem;
      width: 50%;
      position: relative;
      overflow: hidden;
      img {
        cursor: pointer;
        width: 100%;
        transition: all 1s ease;
      }
      .type {
        position: absolute;
        bottom: 0.3rem;
        right: .35rem;
        font-size: .32rem;
        color: #fff;
        font-family: "fangzang";
      }
      .eng_type {
        font-family: "Times New Roman", Times, serif;
        font-size: 0.25rem;
      }
    }
    .sectionType > div:hover img {
      transform: scale(1.1);
    }
    .section {
      .exhibitionContent {
        margin-top: 0.5rem;
        width: 100%;
        padding-bottom: 0.5rem;
        display: flex;
        flex-wrap: wrap;
        .exhibitionItemss {
          cursor: pointer;
          margin-bottom: 0.2rem;
          margin-right: 6%;
          // height: 3rem !important;
          width: 47%;
          position: relative;
          overflow: hidden;
          .Imgs {
            cursor: pointer;
            position: relative;
            height: 2.4rem !important;
            width: 3.35rem !important;
            overflow: hidden;
            .imgs {
              height: 100%;
              width: 100%;
              margin-bottom: 0.1rem !important;
              object-fit: cover;
              transition: all 1s ease;
            }
            .masks {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              // transform: translateY(100%);
              // transition: all 0.5s ease;
              .Toptitles {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background-color: #0e162d;
                opacity: 0.9;
                padding: 0.1rem 0.15rem;
                text-align: center;
                .title {
                  font-family: "fangzang";
                  font-size: 0.3rem;
                  background: linear-gradient(to bottom, #fffdb6, #ffc000);
                  -webkit-background-clip: text;
                  color: transparent;
                }
                .eng_title {
                  font-size: 0.22rem;
                }
              }
            }
          }
          .bottomTitle {
            width: 100%;
            text-align: center;
            font-size: .32rem;
            padding-top: .12rem;
            font-family: "fangzang";
          }
          .za_bottomTitle {
            font-size: .32rem;
          }
          .eng_bottomTitle {
            font-size: .28rem;
          }
        }
        .exhibitionItemss:nth-child(2n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
